"use client";

import { ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";
import { shouldShowMobileStickyCta } from "@/lib/landingCtaVisibility";
import { MarketingTrackedLink } from "./MarketingTrackedLink";

export function MobileStickyCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const heroCta = document.getElementById("hero-primary-cta");
    const finalCtaSection = document.getElementById("final-cta-section");
    const siteFooter = document.getElementById("site-footer");

    if (!heroCta) {
      return;
    }

    let isHeroVisible = true;
    let isFinalCtaVisible = false;
    let isFooterVisible = false;
    const syncVisibility = () => setIsVisible(shouldShowMobileStickyCta({ isHeroCtaVisible: isHeroVisible, isFinalCtaVisible, isFooterVisible }));

    const heroObserver = new IntersectionObserver(([entry]) => {
      isHeroVisible = entry.isIntersecting;
      syncVisibility();
    });
    heroObserver.observe(heroCta);

    const endBoundaryObserver = finalCtaSection || siteFooter
      ? new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.target === finalCtaSection) {
              isFinalCtaVisible = entry.isIntersecting;
            }
            if (entry.target === siteFooter) {
              isFooterVisible = entry.isIntersecting;
            }
          }
          syncVisibility();
        }, { threshold: 0.08 })
      : null;

    if (finalCtaSection && endBoundaryObserver) {
      endBoundaryObserver.observe(finalCtaSection);
    }
    if (siteFooter && endBoundaryObserver) {
      endBoundaryObserver.observe(siteFooter);
    }

    return () => {
      heroObserver.disconnect();
      endBoundaryObserver?.disconnect();
    };
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-green-200/80 bg-white/95 px-3 pt-2 shadow-[0_-18px_45px_-30px_rgba(15,23,42,0.55)] backdrop-blur-sm pb-[calc(env(safe-area-inset-bottom)+0.5rem)] md:hidden">
      <MarketingTrackedLink
        href="/sign-up"
        ctaId="mobile_sticky"
        ctaLabel="Generate my first lesson free"
        className="mx-auto flex min-h-11 w-full max-w-md items-center justify-center gap-2 rounded-full bg-[#08A62F] px-4 py-2 text-sm font-black text-white shadow-[0_14px_28px_-18px_rgba(8,166,47,0.95)] transition-colors duration-150 hover:bg-[#078F2B] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700"
      >
        <span>Generate my first lesson free</span>
        <ArrowRight className="h-4 w-4 shrink-0" strokeWidth={2.7} aria-hidden />
        <span className="sr-only">7 days free, no card required</span>
      </MarketingTrackedLink>
      <p className="mt-1 text-center text-[11px] font-semibold text-slate-500">7 days free · No card required</p>
    </div>
  );
}
